module.exports = new __parcel__URL__("oncall-preview-dark.44c69321.svg").toString();